import React, { useState, useEffect } from 'react';

import Registry from './Registry/RegistryV2';
import WebsitePreview from '../../WebsitePreview';

import RegistryOnboardContainer from './RegistryOnboardContainer';

// hasZolaRegistry: state.user.userContext.registry_ids.length > 0,
// hasOtherRegistries: state.website.entities.orderedIds.length > 0,

const RegistryContainer = ({ getRegistryEntities, hasRegistry }) => {
  const [registriesReceived, setRegistriesReceived] = useState(false);

  useEffect(() => {
    getRegistryEntities(() => setRegistriesReceived(true));
  }, []);

  if (registriesReceived && !hasRegistry) {
    return <RegistryOnboardContainer />;
  }
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="column col-xs-12 col-md-5">
          <Registry useDragHandle lockAxis="y" />
        </div>
        <div className="column col-md-7 hidden-sm hidden-xs">
          <WebsitePreview pageType="REGISTRY" />
        </div>
      </div>
    </div>
  );
};

export default RegistryContainer;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/RegistryContainer/RegistryContainer.jsx